/**
 * Generated by orval v8.23.0 🍺
 * Do not edit manually.
 * Arbi API
 * OpenAPI spec version: 1.0.0
 */

export interface StateOut {
  id: string;
  state: string;
  state_reason: string | null;
  state_stage: string | null;
  capture_outcome: string | null;
  partial: boolean;
  partial_reason: string | null;
  updated_at: string;
}
